export const schemaFormTypes = {
    hoc: "hoc",
    widget: "widget",
    template: "temp",
    field: "field"
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/fx-schema-form-react/libs/models/index.js
// module id = 10
// module chunks = 3